{
  "lang": "de",
  "alias": "iframe",
  "theme": "template-iframe",
  "master": "masters/template-iframe/vogel-partner",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-user-detect",
    "asterisk",
    "case-template",
    "change-nav-text",
    "close-caseslist",
    "custom-checkboxes",
    "dialog",
    "end-tools",
    "has-no-next",
    "headings",
    "history",
    "iconset",
    "info-inline",
    "language-auto-switch",
    "md-labels",
    "model-filter",
    "modelinfo",
    "modelitem",
    "non-indenting-jumplist",
    "reset-password",
    "shout-out-resize",
    "show-server-side-validation",
    "showdown",
    "showdown-converter"
  ],
  "arbitrary": {
    "jumplisttitle": "Steps:",
    "headings": {
      "baseLevel": "2"
    },
    "languageLayers": {
      "base-layer": "bb.html",
      "en-us": "en.html",
      "de-de": "bb.html"
    },
    "parentDomain": [
      "https://www.vogel-partner.eu/"
    ]
  },
  "template": {
    "less": {
      "post": [
        "theme.less",
        "sizes.less",
        "jumplist.less",
        "info-inline.less"
      ]
    },
    "readonly-prop": "disabled"
  },
  "fonts": [
    "myriadpro",
    "arquitecta"
  ]
}
